(() => {
  if (window.rbAutumnChrome) return;
  let current;
  function init() {
    const builder = document.querySelector('rbnl-autumn-builder-v1[data-rb-compact]');
    const header = document.querySelector('store-header');
    if (!builder || !header || current?.header === header) return;
    current?.cleanup();
    const search = header.querySelector('.header__search');
    const icons = header.querySelector('.header__icons');
    if (!search || !icons) return;
    const originalId = search.id;
    if (!search.id) search.id = 'rb-autumn-header-search';
    header.setAttribute('data-rb-autumn-header', '');
    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'header__icon rb-autumn-search-toggle';
    toggle.setAttribute('aria-label', 'Zoeken');
    toggle.setAttribute('aria-controls', search.id);
    toggle.setAttribute('aria-expanded', 'false');
    toggle.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5" stroke="currentColor" stroke-width="1.8"/><path d="m16 16 5 5" stroke="currentColor" stroke-width="1.8"/></svg>';
    icons.prepend(toggle);
    let frame = 0;
    const update = () => {
      frame = 0;
      const compact = innerWidth < 769 && scrollY > (header.hasAttribute('data-rb-header-compact') ? 80 : 200);
      const changed = header.hasAttribute('data-rb-header-compact') !== compact;
      header.toggleAttribute('data-rb-header-compact', compact);
      if (compact && search.contains(document.activeElement)) header.setAttribute('data-rb-search-open', '');
      if (!compact) header.removeAttribute('data-rb-search-open');
      toggle.setAttribute('aria-expanded', String(header.hasAttribute('data-rb-search-open')));
      if (changed) window.setHeaderHeight?.();
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    const closeSearch = () => {
      header.removeAttribute('data-rb-search-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus({preventScroll: true});
      window.setHeaderHeight?.();
    };
    toggle.addEventListener('click', () => {
      if (header.hasAttribute('data-rb-search-open')) { closeSearch(); return; }
      header.setAttribute('data-rb-search-open', '');
      toggle.setAttribute('aria-expanded', 'true');
      search.querySelector('input[type="search"]')?.focus({preventScroll: true});
      window.setHeaderHeight?.();
    });
    const onKey = event => { if (event.key === 'Escape' && header.hasAttribute('data-rb-search-open')) closeSearch(); };
    header.addEventListener('keydown', onKey);
    window.addEventListener('scroll', schedule, {passive: true});
    window.addEventListener('resize', schedule);
    const observer = new ResizeObserver(() => {
      window.setHeaderHeight?.();
      header.setHeaderEnd?.();
      builder.boundStickyOffset?.();
    });
    observer.observe(header);
    // Shopify Forms renders its teaser in a shadow root. Keep the actual form available.
    let formsTimer = 0;
    let formsStyle;
    let disposed = false;
    const attachTeaserStyle = (attempt = 0) => {
      if (disposed) return;
      const root = document.getElementById('app-embed-container-1109079')?.shadowRoot;
      if (root) {
        formsStyle = document.createElement('style');
        formsStyle.textContent = '[data-form-root][data-current-step="tease"]{display:var(--rb-autumn-teaser-display,block)!important}';
        root.append(formsStyle);
      } else if (attempt < 60) {
        formsTimer = setTimeout(() => attachTeaserStyle(attempt + 1), 500);
      }
    };
    customElements.whenDefined('shopify-forms-embed').then(() => attachTeaserStyle());
    const cleanup = () => {
      disposed = true;
      clearTimeout(formsTimer);
      formsStyle?.remove();
      cancelAnimationFrame(frame);
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      header.removeEventListener('keydown', onKey);
      observer.disconnect();
      toggle.remove();
      header.removeAttribute('data-rb-autumn-header');
      header.removeAttribute('data-rb-header-compact');
      header.removeAttribute('data-rb-search-open');
      if (!originalId) search.removeAttribute('id');
      window.setHeaderHeight?.();
      current = null;
    };
    current = {header, builder, cleanup};
    update();
  }
  window.rbAutumnChrome = {init};
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    if (current && (event.target.contains(current.builder) || event.target.contains(current.header))) current.cleanup();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
